"use client";

import { trackGtmEvent } from "@/lib/analytics/gtm";
import type { IAnalyticsEventMap, TAnalyticsEventName } from "@/lib/analytics/events";

function analyticsEnvironment(): string {
  return (
    process.env.NEXT_PUBLIC_VERCEL_ENV ??
    process.env.NODE_ENV ??
    "development"
  );
}

/**
 * Push a typed, consent-gated event to the dataLayer (via GTM).
 * Callers must not include PII; payloads are merged as-is for GTM mapping.
 */
export function trackAnalyticsEvent<K extends TAnalyticsEventName>(
  event: K,
  payload: IAnalyticsEventMap[K]
): void {
  const base = {
    event,
    analytics_env: analyticsEnvironment(),
    analytics_source: "web",
  } as Record<string, unknown>;

  const merged = {
    ...base,
    ...(payload as Record<string, unknown>),
  };

  trackGtmEvent(merged as { event: string } & Record<string, unknown>);
}
